<div class="card-article-header">
    @if (resolvedImage(); as image) {
        <div class="card-article-media">
            <sirius-image-item [image]="image" [autocrop]="true" [imageData]="imageData()" alt="" />
            @if (isVideo()) {
                <sirius-play-button class="card-article-play" [hovered]="isHighlighted()" [focusable]="false" />
            }
        </div>
    }
    @if (resolvedAttributes().length) {
        <sirius-chips
            class="card-article-attributes"
            [chips]="resolvedAttributes()"
            [ariaLabel]="'card.article.attributes' | translate"
        />
    }
</div>
<div class="card-article-body">
    @if (resolvedPublishedAt(); as publishedAt) {
        @if (resolvedDate(); as date) {
            <time class="card-article-date sir-text-style-system-m-default" [attr.datetime]="date">{{
                publishedAt
            }}</time>
        } @else {
            <span class="card-article-date sir-text-style-system-m-default">{{ publishedAt }}</span>
        }
    }
    <a class="card-article-link" [siriusLink]="resolvedLink()" (linkSelect)="onClick()">
        <sirius-heading [text]="resolvedTitle()" textStyleSize="s" [h]="3" />
    </a>
    @if (resolvedTextHtml()) {
        <sirius-text-html [html]="resolvedTextHtml()" textStyleSize="m" />
    }
    @if (resolvedTags().length) {
        <sirius-chips
            class="card-article-tags"
            [chips]="resolvedTags()"
            [ariaLabel]="'card.article.tags' | translate"
        />
    }
</div>
